export enum AuthRoutes {
  Signup = 'signup',
  Signin = 'signin',
  Forgotpassword = 'forgot-password',
  Resetpassword = 'reset-password'
}
